import Repository from '@/libs/axios'
import OperationsRepository from '@/libs/customAxios/operationAxios'

const businessSettingsResource = '/admin/settings/business'
const businessSettingsPublicResource = '/settings/business'
const businessSettingsLogoResource = '/admin/settings/business/logo'
const businessSettingsForLoginResource = '/settings/business'
// const defaultPagination = 10
export default {
  getbusinessSettingsResource() {
    return OperationsRepository.get(`${businessSettingsResource}`)
  },
  getbusinessPublicSettingsResource() {
    return OperationsRepository.get(`${businessSettingsPublicResource}`)
  },
  getbusinessSettingsForLoginResource() {
    return OperationsRepository.get(`${businessSettingsForLoginResource}`)
  },
  updatebusinessSettingsResource(payload) {
    return OperationsRepository.put(`${businessSettingsResource}`, payload)
  },
  updatebusinessSettingsLogoResource(payload) {
    const formData = new FormData()
    formData.append('file', payload)
    return Repository.post(`${businessSettingsLogoResource}`, formData)
  },
}
